/** Die Klasse, an der die **Aufgaben-Details** im DOM zu erkennen sind. */
const TASK_DETAILS_SELECTOR = '.task-details'

/**
 * **Steht der Zeiger in den Aufgaben-Details?** Dann gehören die Tasten ihnen.
 *
 * Die Tastatur gehört der **Aufgabenliste** — bis jemand in die Aufgaben-Details
 * hineinklickt oder mit Tabulator hineingeht (CONTEXT.md, Aufgaben-Details). Ab
 * da gehört sie ihnen: „Wer dort tippt, hat sie ausdrücklich angefasst."
 *
 * Die Griffe der Projektseite hängen an `window` und sehen jedes Ereignis; ihr
 * bisheriger Wächter war „steht der Zeiger in einem INPUT/TEXTAREA?". Der reicht
 * hier nicht: In den Aufgaben-Details steht der Fokus die meiste Zeit auf einem
 * KNOPF — eine Stufe der Aufmerksamkeit, ein Tag, ein Tag im Kalender, ein
 * Eintrag im Katalog. `W` öffnete dann das **Aufgaben-Menü**, `A` legte eine
 * Aufgabe an, `C` holte den Canvas herein — und schlösse damit die
 * Aufgaben-Details, in denen man gerade arbeitet.
 *
 * Über die Klasse und nicht über einen Ref: Die Griffe liegen in Hooks, die die
 * Aufgaben-Details nicht kennen und auch nicht kennen sollen — sie sind eine
 * Ansicht auf ihre Auswahl, kein Teil ihrer Verdrahtung.
 *
 * @example
 * if (isInsideTaskDetails(e.target)) return
 */
export function isInsideTaskDetails(target: EventTarget | null): boolean {
  return target instanceof Element && !!target.closest(TASK_DETAILS_SELECTOR)
}
